import React from 'react';
import Anime from 'react-anime';
import CustomScroll from 'react-custom-scroll';
import BackToHomeBtn from './BackToHomeBtn';
import mail from '../assets/mail.svg';
import github from '../assets/github.svg';
import twitter from '../assets/twitter.svg';
import medium from '../assets/medium.svg';
import linkedin from '../assets/linkedin.svg';
import codepen from '../assets/codepen.svg';
import instagram from '../assets/quora.svg';
import facebook from '../assets/facebook.svg';
import '../styles/ContactsPage.css';

const ContactsPage = props => {
  return(
    <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
      <div className="contacts-page">
          <BackToHomeBtn handleClick={props.returnBtn}/>
          <Anime easing="easeOutCubic" left={[-350, -130]} duration={500} delay={800}>
            <p className="page-tag">Contacts</p>
          </Anime>
          <div className="page-content">
            <h1>Let's get in touch!</h1>
            <p>If you have a interesting project/opportunity or you just want to chat ,feel free to reach out. </p>
            <div className="link-list">
              <ul>
                <li><a href="mailto:himanshubarak@gmail.com" target="_blank"><img src={mail} alt="Mail me!"/></a></li>
                <li><a href="https://github.com/HimanshuBarak" target="_blank"><img src={github} alt=""/></a></li>
                <li><a href="https://www.linkedin.com/in/himanshubarak/" target="_blank"><img src={linkedin} alt=""/></a></li>
                <li><a href="#" target="_blank"><img src={twitter} alt=""/></a></li>
                <li><a href="https://medium.com/@himanshubarak" target="_blank"><img src={medium} alt=""/></a></li>
                <li><a href="https://codepen.io/himanshubarak" target="_blank"><img src={codepen} alt=""/></a></li>
                <li><a href="https://www.instagram.com/__himaniac__/" target="_blank"><img src={instagram} alt=""/></a></li>
              </ul>
            </div>
          </div>
      </div>
    </Anime>
  )
}

export default ContactsPage;


// WEBPACK FOOTER //
// ./src/components/ContactsPage.js